import {Injectable} from "@angular/core";

@Injectable()
export class HttpDataPovider{
	public mkeys = {};

	// get userGroup(){
	// 	return this.keys["mUserGroup"];
	// }
	set userGroup(userGrp:number){
		if (!userGrp){
			delete this.keys["viewMode"];
		}else {
			this.keys["viewMode"] = userGrp;
		}
	}

	get keys(){
		return this.mkeys;
	}
}


